/**
 * Does the recorded tutorial expect the next board command to open the Action
 * Intent dialog?
 *
 * WHY THIS IS A MODULE AND NOT AN IMPORT. `action-intent.js` has to ask the
 * tutorial this question, but it cannot import `tutorial.js`: that module
 * imports `lobby.js`, which imports `action-intent.js` — a three-module cycle
 * whose bindings resolve differently under the bundler than they do as raw
 * ESM. This file imports nothing, so both sides can depend on it and neither
 * depends on the other.
 *
 * It is a PREDICTION, never a permission. The server decides whether an action
 * takes the intent path and answers it out of the recording; this only keeps
 * the client from asking for a step the script does not have, which would
 * strand the player on a spinner. Wrong here costs a refused request, not a
 * desynced board.
 */

let expected = false;

const TutorialIntentGate = {
  /** Called by the tutorial as each step's restrictions are applied. */
  set(next) {
    expected = next === true;
  },
  isExpected() {
    return expected;
  },
  /** The script is over (or was skipped); fall back to normal live rules. */
  reset() {
    expected = false;
  },
};

export { TutorialIntentGate };
